<!-- فرم مشاهده فعالیت های کاربر -->
<template>
    <div class="row">
        <div class="col-12 p-0">
            <div class="row p-0 d-flex justify-content-between align-items-center">
                <div class="col-4 p-0 pb-2">
                    <div class="input-group p-0">
                        <input
                        id="ActivetyListTextSearch"
                        placeholder="جستجو پیشرفته در لیست فعالیت ها (Enter)"
                        type="text"
                        class="form-control form-control-sm rounded-0"
                        v-on:focus="$event.target.select()"
                        v-on:keyup.enter="searchData($event.target.value)"
                        />
                        <div class="input-group-prepend rounded-0">
                        <span
                            class="
                            input-group-text input-group-box-size
                            bg-secondary
                            rounded-left
                            white-text
                            "
                        >
                            <a v-on:click="searchData('Search')">
                            <i class="fas fa-search"></i>
                            </a>
                        </span>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
        <div class="table-responsive">
            <table
                class="
                table table-bordered table-sm
                text-center
                table-font-size
                "
            >
                <thead style="background-color: #f7f7f7; height: 32px;">
                    <td>
                        <!-- انتقال به سطر انتهایی -->
                        <a
                        v-on:click="scrollTable('LastRowActivetyList')"
                        title="مشاهده سطر انتهایی"
                        >
                            <i class="far fa-arrow-alt-circle-down fa-1x-half text-secondary"></i>
                        </a>
                    </td>
                    <td colspan="13">
                        تعداد سطرهای گزارش : {{ this.TbActivityListFilterData.length }} مورد
                    </td>
                </thead>
                <!-- سربرگ جدول -->
                <thead class="text-light bg-secondary">
                    <td style="max-width: 50px;">ردیف</td>
                    <!-- <td>کد ملی</td> -->
                    <!-- <td>نام و نام خانوادگی</td> -->
                    <!-- <td>فعالیت</td> -->
                    <td>تاریخ فعالیت</td>
                    <td>IP اتصال</td>
                    <td>عنوان فعالیت</td>
                    <td>اطلاعات تکمیلی</td>
                </thead>
                <!-- بدنه جدول -->
                <tbody>
                    <template v-for="(row, index) in getTbActivityListDataPaging(intPageNumber, intCountRow)">
                        <tr
                            :key="row.NUserLogId"
                            :class="{ selRow: SelectRowID == row.RowIndex }"
                            v-on:click="SaveRowSelect(row.RowIndex)"
                            v-bind:id="row.NUserLogId"
                            style="cursor: pointer;"
                        >
                            <!-- ردیف -->
                            <td
                            style="
                                max-width: 50px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.RowIndex }}
                            </td>
                            <!-- کد ملی -->
                            <!-- <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.NPerNationalId }}
                            </td> -->
                            <!-- نام و نام خانوادگی -->
                            <!-- <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.SUserName }}
                            </td> -->
                            <!-- فعالیت -->
                            <!-- <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.ActivityTypeText }}
                            </td> -->
                            <!-- تاریخ فعالیت -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                direction: ltr;
                            "
                            >
                            {{ row.DateTimeOperation }}
                            </td>
                            <!-- IP اتصال -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                direction: ltr;
                            "
                            >
                            {{ row.SSystemIP }}
                            </td>
                            <!-- عنوان فعالیت -->
                            <td
                            style="
                                max-width: 120px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            "
                            >
                            {{ row.OperationText }}
                            </td>
                            <!-- اطلاعات تکمیلی -->
                            <td style="text-align: right !important; padding-right: 5px !important; max-width: 250px;">
                                <DescriptionByTooltip
                                    v-bind:DescritionData="row.OperationDetails"
                                    v-bind:showTop= "((index + 5) < LenRowActivityListData ? false : true)"
                                ></DescriptionByTooltip>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <!-- پابرگ جدول -->
                <tfoot style="background-color: #f7f7f7" id="LastRowActivetyList">
                    <td>
                        <!-- انتقال به سطر ابتدایی -->
                        <a
                        v-on:click="scrollTable('ActivetyListTextSearch')"
                        title="مشاهده سطر ابتدایی"
                        >
                            <i class="far fa-arrow-alt-circle-up fa-1x-half text-secondary"></i>
                        </a>
                    </td>
                    <td colspan="13">
                        <nav aria-label="..." v-if="getCountPage() > 1">
                            <ul class="pagination flex-wrap m-0 p-0 px-1 d-flex justify-content-center align-items-center">
                                <template v-for="(row, index) in getCountPage()">
                                    <li 
                                        :key="index"
                                        class="page-item d-flex justify-content-center align-items-center" 
                                        :class="{active: intPageNumber == (index + 1)}"
                                        aria-current="page" 
                                        style="min-width: 35px; max-width: 35px; text-align: center;"
                                    >
                                        <span class="page-link" v-if="intPageNumber == (index + 1)">{{index + 1}}</span>
                                        <a class="page-link" v-on:click="intPageNumber = (index + 1)" v-else>{{index + 1}}</a>
                                    </li>
                                </template>
                                <!-- تعیین تعداد رکورد در هر صفحه -->
                                <li class="page-item d-flex align-items-center mr-2" style="max-width: 65px;">
                                    <select class="form-control form-control-sm rounded-3" v-model="intCountRow">
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                        <option value="500">500</option>
                                        <option value="1000">1000</option>
                                    </select>
                                </li>
                            </ul>
                        </nav>
                    </td>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import DescriptionByTooltip from "../PublicComponents/DescriptionByTooltip.vue";

export default {
    components: {
        DescriptionByTooltip
    },
    data() {
        return {
            // آیدی سطر کلیک شده
            SelectRowID: 1,
            // لیست محلی فعالیت کاربران
            TbActivityListMasterData: [],
            // وضعیت بایگانی لیست فعالیت ها
            IsArchive: false,
            // لیست محلی فیلتر شده بر اثر جستجو
            TbActivityListFilterData: [],
            // فیلد نگهداری نام آخرین فیلد مرتب سازی شده
            lastSortFieldName: '',
            // آدرس تصویر لطفا صبر کنید
            waitImage: this.$store.getters.getImageUrl + "wait.gif",
            // کنترل نمایش ویرایش اطلاعات پروفایل
            isShowEditPerson: false,
            // اطلاعات شخصیت جهت ویرایش
            PersonDataForEdit: {},
            // کنترل تعریف شخصیت جدید
            isShowAddNewPerson: false,
            // شماره صفحه
            intPageNumber: 1,
            // تعداد سطرها در هر صفحه
            intCountRow: 200,
            // آیا سوابق فعالیت برای کاربر خاص فیلتر شود
            // اگر کد ملی کاربر خالی نبود فیلتر می شود
            FilterUserID: '',
            // تعداد سطر موجود در صفحه جاری
            LenRowActivityListData: 0,
        }
    },
    created(){
        this.getTbActivityListData();
    },
    methods: { 
        // جابجایی به سطر جمع یا سربرگ
        scrollTable(objectID) {
            console.log(objectID);
            $("#" + objectID).scrollintoview({
                duration: 500,
            });
        },
        
        // دریافت اطلاعات لیست فعالیت کاربران از مخزن 
        async getTbActivityListData() {
            // دریافت لیست فعالیت کاربران
            let token = await this.$store.getters.getUserData.token;
            // آیا سوابق فعالیت برای کاربر خاص فیلتر شود
            // اگر کد کاربر صفر نبود فیلتر می شود
            this.FilterUserID = await this.$store.getters.getOnlyShowActivityListForUserID;
            this.TbActivityListMasterData = await this.$store.dispatch("getTbActivityListDataFromSever",{token});
            // انتقال مخزن اصلی فرم به مخزن مخصوص فیلتر
            this.TbActivityListFilterData = this.TbActivityListMasterData;
            // درج شماره ردیف برای سطرها
            this.callSortRowIndex();
        },

        // رویداد ویرایش حساب کاربری
        async CallEditPerson(NPerID){
            // جستجو در مخزن اصلی فرم و استخراج اطلاعات شخصیت مورد نظر
            let index = this.TbActivityListFilterData.findIndex(itme => itme.NPerID == NPerID)
            if(index != -1){
                // ارسال اطلاعات شخصیت به مودال ویرایش اطلاعات
                this.PersonDataForEdit = await this.TbActivityListFilterData[index];
            }
            // فراخوانی کامپاننت ویرایش اطلاعات
            this.isShowEditPerson = true;
        },

        // نمایش اطلاعات سوابق فعالیت با قابلیت صفحه بندی
        getTbActivityListDataPaging(pageNumber, countRow){
            // بررسی اعتبار شماره صفحه
            if (parseInt(pageNumber) > this.getCountPage()){
                pageNumber = 1;
                this.intPageNumber = 1;
            }
            // لیست محلی اشخاص
            let TbActivityListDataPagingDataPaging = [];
            // شماره شروع رکورد
            let startRowIndex = pageNumber == 1 ? 1 : (parseInt(countRow) * (parseInt(pageNumber) -1) + 1);
            // انتخاب رکوردهای صفحه مورد نظر
            TbActivityListDataPagingDataPaging = this.TbActivityListFilterData.filter(function(item){
                return (item.RowIndex >= startRowIndex && item.RowIndex < (parseInt(startRowIndex) + parseInt(countRow)))
            });
            this.LenRowActivityListData = TbActivityListDataPagingDataPaging.length;
            return TbActivityListDataPagingDataPaging;
        },
        
        // دریافت تعداد صفحات لیست اشخاص
        getCountPage(){
            if(this.TbActivityListFilterData != null && this.TbActivityListFilterData.length > 0){
                let intCountPage = this.TbActivityListFilterData.length;
                intCountPage = intCountPage / this.intCountRow;
                if(this.TbActivityListFilterData.length % this.intCountRow){
                    intCountPage ++;
                }
                return parseInt(intCountPage);
            } else {
                return 1;
            }
        },

        // نگهداری اطلاعات سطر انتخاب شده
        SaveRowSelect(RowIndex) {
            this.SelectRowID = RowIndex;
        },

        // جستجو/فیلتر در لیست سوابق فعالیت
        searchData(searchValue) {
            // ریست شماره صفحه
            this.intPageNumber = 1;
            //
            if (searchValue === "Search") {
                searchValue =
                $("#ActivetyListTextSearch").val() != ""
                    ? $("#ActivetyListTextSearch").val()
                    : "";
            }
            if (searchValue != "") {
                this.TbActivityListFilterData = this.TbActivityListMasterData.filter(function(item){
                    return (item.NPerNationalId.toString().startsWith(searchValue) ||
                        item.SUserName.toString().includes(searchValue) ||
                        // item.ActivityTypeText.toString().includes(searchValue) ||
                        item.DateTimeOperation.toString().startsWith(searchValue) ||
                        item.SSystemIP.toString().startsWith(searchValue) ||
                        item.OperationText.toString().includes(searchValue) ||
                        item.OperationDetails.toString().includes(searchValue))
                });
                if(this.TbActivityListFilterData.length > 0){
                    // انتخاب اولین سطر پیدا شده
                    this.SaveRowSelect(this.TbActivityListFilterData[0].RowIndex);
                    // اصلاح شماره ردیف ها
                    // this.callSortRowIndex();
                } else {
                    this.SelectRowID = 1;
                }
            } else {
                this.TbActivityListFilterData = this.TbActivityListMasterData;
                // اصلاح شماره ردیف ها
                // this.callSortRowIndex();
            }
        },

        // مرتب سازی شماره ردیف ها
        callSortRowIndex(){
            if(this.TbActivityListFilterData.length > 0){
                // اصلاح شماره ردیف ها
                for (var i = 0 ; i < this.TbActivityListFilterData.length; i++){
                    this.TbActivityListFilterData[i].RowIndex = i + 1;
                }
            }
        },

        // مرتب سازی لیست بر اساس فیلد انتخابی
        sortDocRow: function (sortFieldName, sortFieldType) {
            // منبع مطلب
            // https://www.codegrepper.com/code-examples/javascript/frameworks/vue/Sort+numbers+in+javascript
            let docrow = this.ListTbDocInfo;
            // بررسی وضعیت مرتب سازی صعودی یا نزولی
            if(sortFieldType === ""){
                if(this.lastSortFieldName === sortFieldName){
                // فیلد تکراری است لذا مرتب سازی از بزرگ به کوچک
                sortFieldType = 'desc';
                // تخلیه نام آخرین فیلد مرتب سازی شده
                this.lastSortFieldName = '';
                } else {
                // فیلد جدید است لذا مرتب سازی از کوچک به بزرگ
                sortFieldType = 'asc';
                // نگهداری نام آخرین فیلد مرتب سازی شده
                this.lastSortFieldName = sortFieldName;
                }
            }
            
            // Set slice() to avoid to generate an infinite loop!
            // تکه تکه کردن() برای جلوگیری از تولید یک حلقه بی نهایت!
            if (docrow.length > 0) {
                if (sortFieldName === "NId") {
                    // شناسه سند
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NId - b.NId);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NId - a.NId);

                } if (sortFieldName === "NYear") {
                    // سال
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NYear - b.NYear);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NYear - a.NYear);

                } else if (sortFieldName === "NDocNu"){
                    // شماره سند
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NDocNu - b.NDocNu);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NDocNu - a.NDocNu);

                } else if (sortFieldName === "SDocDate") {
                    // تاریخ
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SDocDate;
                            f2 = b.SDocDate;
                        } else {
                            f1 = b.SDocDate;
                            f2 = a.SDocDate;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                } else if (sortFieldName === "SDocType"){
                    // نوع سند
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SDocType;
                            f2 = b.SDocType;
                        } else {
                            f1 = b.SDocType;
                            f2 = a.SDocType;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                } else if (sortFieldName === "SDocDesc") {
                    // شرح سند
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SDocDesc;
                            f2 = b.SDocDesc;
                        } else {
                            f1 = b.SDocDesc;
                            f2 = a.SDocDesc;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                } else if (sortFieldName === "NDebit") {
                    // بدهکار
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NDebit - b.NDebit);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NDebit - a.NDebit);
                } else if (sortFieldName === "NCredit") {
                    // بستانکار
                    // مرتب سازی فیلد عددی
                    if(sortFieldType === 'asc')
                        this.ListTbDocInfo = docrow.sort((a, b) => a.NCredit - b.NCredit);
                    else
                        this.ListTbDocInfo = docrow.sort((a, b) => b.NCredit - a.NCredit);
                } else if (sortFieldName === "SStatus") {
                    // وضعیت سند
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SStatus;
                            f2 = b.SStatus;
                        } else {
                            f1 = b.SStatus;
                            f2 = a.SStatus;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                } else if (sortFieldName === "SOrgCode") {
                    // سازمان
                    // مرتب سازی فیلد متنی
                    this.ListTbDocInfo = docrow.sort((a,b) => {
                        let f1 = '', f2 = '';
                        if(sortFieldType === 'asc'){
                            f1 = a.SOrgCode;
                            f2 = b.SOrgCode;
                        } else {
                            f1 = b.SOrgCode;
                            f2 = a.SOrgCode;
                        }

                        if (f1 < f2) {
                            return -1
                        }
                        if (f1 > f2) {
                            return 1
                        }
                        return 0
                    });
                }
            } else {
                return [];
            }
        },

    },

}
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.pagination .page-item .page-link:hover{
    background-color: #efff6e;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ActivityList/ActivityList.vue